import { useState } from "react"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"


import Layout from "../../layouts/layout"
import MainPageLayout from "../../components/main-page-layout/mainPageLayout"
import Loading from "../../components/loading/loading"
// import WorkshopCard from "../../components/workshop-card/workshopCard"


import { ReactComponent as View } from "../../assets/icons/generals/view.svg"
import { ReactComponent as Edit } from "../../assets/icons/generals/Edit.svg"
import { ReactComponent as Delete } from "../../assets/icons/generals/Delete.svg"
import { ReactComponent as Filter } from "../../assets/icons/shapes/filter.svg"
import { useRequestProcessor } from "../../api/requestProcessor"
import { deleteSingleBlog, getAllBlogs } from "../../api/blogs"
import { confirmAlert } from "react-confirm-alert"
import Pagination from "../../components/pagination/pagination"
import { domainName } from "../../constants/site"
import ViewBlogModal from "../../components/modal/view/view-order"



const Blogs = () => {

    const naviagte = useNavigate()
    const [activeTab, setActiveTab] = useState(0)
    const [searchKeyword, setSearchKeyword] = useState("")
    const [page, setPage] = useState(1)

    const [selected, setSelected] = useState()
    const [isModalOpen, setIsModalOpen] = useState(false)

    function onConfirm() {
        setIsModalOpen(false)
    }

    async function onDeleteHandler(data, type) {
        confirmAlert({
            overlayClassName: "modalBackDrop-bg",
            customUI: ({ onClose }) => {
                return (
                    <div className='bg-white wsm:w-full w-[750px] py-8 px-4 rounded-xl font-bold'>
                        <h1 className=" text-center pb-4">
                            {"آیا از حذف " + type + " " + data.title + " مطمعن هستید؟"}
                        </h1>
                        <div className="flex justify-around ">

                            <button className="" onClick={onClose}>خیر</button>
                            <button className="border-2 text-red-500 rounded-lg py-3 !px-5 border-red-500"
                                onClick={() => { deleteMutate(data.id); onClose() }}>
                                بله
                            </button>
                        </div>
                    </div>
                );
            }
        })
    }

    const { Query, Mutate } = useRequestProcessor()

    const { data, isLoading, isError, refetch } = Query(
        ['getAllBlogs', searchKeyword, page],
        () => getAllBlogs(searchKeyword, page),
        { enabled: Boolean(searchKeyword) || searchKeyword == "" }
    );




    const { mutate: deleteMutate } = Mutate(
        "deleteBlog",
        deleteSingleBlog,
        {
            onSuccess: (data) => {
                toast.success(data.message)//This is the response you get back
                refetch()
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );


    const handlePageClick = (event) => {
        setPage(event.selected + 1);
    };


    return (
        <Layout>
            <MainPageLayout title={"بلاگ ها"} buttonTitle={"بلاگ جدید"} buttonLink={"/admin/blogs/create"}
            // customClass={"!grid !grid-cols-4 !gap-y-8 !gap-x-6 min-h-full wsm:!grid-cols-2"}
            >
                {isModalOpen && <ViewBlogModal data={selected} onConfirm={onConfirm} />}

                <div className="flex justify-between py-3 items-center  wsm:flex-col-reverse">
                    <div className="flex [&>*]:px-4 [&>*]:py-1 p-2 bg-[#eef3f7] rounded-lg text-[#5e6278]">
                        <button onClick={() => setActiveTab(0)} className={activeTab === 0 ? "bg-white rounded-lg text-black" : ""}>همه</button>
                        {/* <button onClick={() => setActiveTab(1)} className={activeTab === 1 ? "bg-white rounded-lg text-black" : ""}>جدید ترین</button>
                        <button onClick={() => setActiveTab(2)} className={activeTab === 2 ? "bg-white rounded-lg text-black" : ""}>قدیمی ترین</button> */}
                    </div>
                    <div className="flex wsm:mb-4">

                        <input type="text" className='form-input !w-full' value={searchKeyword}
                            onChange={(e) => setSearchKeyword(e.target.value)}
                            placeholder='جستوجو بلاگ ها ...' />

                        <span className="flex text-sky-500 font-serif items-center mr-3 cursor-pointer">
                            <Filter width={24} height={24} />
                            فیلتر
                        </span>
                    </div>
                </div>
                <table className="table-auto transition-all" >
                    <thead className="!py-2">
                        <tr className=" border-b border-black">
                            <th className="py-3">#</th>
                            <th className="py-3">بنر</th>
                            <th className="py-3">عنوان</th>
                            <th className="py-3">توضیحات</th>
                            <th className="py-3">دسته بندی</th>
                            {/* <th className="py-3">تعداد بازدید</th> */}
                            {/* <th className="py-3">ایجاد شده توسط</th> */}
                            {/* <th className="py-3">زمان ایجاد</th> */}
                            <th className="py-3">عملیات</th>
                        </tr>
                    </thead>
                    {
                        !isLoading &&
                        <tbody>
                            {
                                data?.data?.length ?
                                    data?.data?.map(el => (
                                        <tr key={el.id} className="text-[#575757] border-b border-[#d5d5d5] hover:bg-[#fafafa]"  >
                                            <td className="text-center py-5" >{el.id}</td>
                                            <td className="text-center py-5 flex justify-center" >
                                                <img src={domainName + el.files[0].file.thumb} className="max-h-[100px]" alt={el.title} width={150} />
                                            </td>
                                            <td className="text-center py-5 max-w-prose text-sm" > {el.title}</td>
                                            <td className="text-center py-5 max-w-prose text-xs" > {el.description}</td>
                                            <td className="text-center py-5 " >
                                                <div className="bg-[#2196f3] py-2 text-white rounded-[1rem]">
                                                    {el.type === "blogs" ? "بلاگ" : "ورک شاپ"}
                                                </div>
                                            </td>
                                            <td className="text-center py-5 "  >
                                                <div className="flex wsm:flex-col wsm:p-0 [&>*]:wsm:py-2 justify-evenly items-center [&>*]:px-2">
                                                    <div className=" cursor-pointer" onClick={() => naviagte("/admin/blogs/" + el.id)}><View width={"20"} height="20" /></div>
                                                    <div className=" cursor-pointer" onClick={() => naviagte("/admin/blogs/edit/" + el.id)}><Edit width={"20"} height="20" /></div>
                                                    <div className=" cursor-pointer" onClick={() => { onDeleteHandler(el, "بلاگ") }}><Delete width={"20"} height="20" /></div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                    :
                                    <div>
                                        <p>هیچ بلاگی پیدا نشد</p>
                                    </div>
                            }
                        </tbody>
                    }
                </table>
                {data?.meta?.last_page > 1 && <Pagination handlePageClick={handlePageClick} lastPage={data?.meta?.last_page} />}
                {
                    isLoading && <Loading />
                }

            </MainPageLayout>
        </Layout>
    )
}

export default Blogs